import { makeVar } from '@apollo/client';

export const currentFlights = makeVar([]);
export const currentFlightsLoading = makeVar(false);
export const liveUpdates = makeVar(false);
export const lastUpdate = makeVar(false);